export default __webpack_public_path__ + "static/media/CorpayBannerBackground.bdf49ea9.png";